"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const ModalShare_1 = __importDefault(require("../../../components/modal/ModalShare"));
const ModalSubUser_1 = require("../../../components/modal/ModalSubUser");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const ModalSubUser = (props) => {
    const { visible, isMute, isBlocked, isBlocking, onClose, modalPosition, userId, userHandle, onBlockUser, onMuteUser, onRepost, } = props;
    const [blockModalVisible, setBlockModalVisible] = (0, react_1.useState)(false);
    const [muteModalVisible, setMuteModalVisible] = (0, react_1.useState)(false);
    const [shareModalVisible, setShareModalVisible] = (0, react_1.useState)(false);
    const distanceFromBottom = react_native_1.Dimensions.get("window").height - modalPosition.y;
    const myProfile = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile);
    const isAnonymous = myProfile?.registration_status == 0;
    const isShowMute = !isBlocked;
    const showBlockModal = () => {
        onClose();
        if (isBlocked) {
            return onBlockUser();
        }
        setBlockModalVisible(true);
    };
    const showMuteModal = () => {
        onClose();
        if (isMute) {
            return onMuteUser();
        }
        setMuteModalVisible(true);
    };
    const handleCloseBlockModal = () => setBlockModalVisible(false);
    const handleCloseMuteModal = () => setMuteModalVisible(false);
    const handleBlockUser = () => {
        setBlockModalVisible(false);
        onBlockUser();
    };
    const handleMuteUser = () => {
        setMuteModalVisible(false);
        onMuteUser();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.Modal, { visible: visible, animationType: "fade", statusBarTranslucent: true, transparent: true, onRequestClose: onClose, onShow: () => {
                helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
            }, onDismiss: () => {
                helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
            }, ...props },
            react_1.default.createElement(react_native_1.TouchableOpacity, { activeOpacity: 1, style: styles.viewContain, onPress: onClose },
                react_1.default.createElement(react_native_1.View, { style: [
                        styles.viewModal,
                        {
                            position: "absolute",
                            top: distanceFromBottom > (0, scale_1.scale)(290)
                                ? modalPosition.y + (0, scale_1.scale)(4)
                                : modalPosition.y - (0, scale_1.scale)(290),
                            left: modalPosition.x - (0, scale_1.scale)(220),
                        },
                    ] },
                    !isAnonymous && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(ModalSubUser_1.MenuItemPressButton, { title: `@${userHandle}を\n${isBlocked ? 'ブロック解除' : 'ブロック'}`, onPress: showBlockModal }),
                        react_1.default.createElement(ModalSubUser_1.MenuItemPressButton, { title: `@${userHandle}を\n${isMute ? 'ミュート解除' : 'ミュート'}`, onPress: showMuteModal }))),
                    react_1.default.createElement(ModalSubUser_1.MenuItemPressButton, { title: `共有`, style: isAnonymous && { borderBottomWidth: 0 }, onPress: () => {
                            setShareModalVisible(true);
                            onClose();
                        } }),
                    !isAnonymous && (react_1.default.createElement(ModalSubUser_1.MenuItemPressButton, { title: `通報`, style: { borderBottomColor: 'transparent' }, onPress: () => {
                            onRepost();
                            onClose();
                        } }))),
                react_1.default.createElement(react_native_1.View, { style: {
                        marginBottom: (0, scale_1.scale)(40),
                        marginTop: (0, scale_1.scale)(20),
                        maxHeight: (0, scale_1.scale)(370),
                    } }))),
        react_1.default.createElement(react_native_1.Modal, { visible: blockModalVisible, animationType: "none", statusBarTranslucent: true, transparent: true, onRequestClose: handleCloseBlockModal, onShow: () => {
                helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
            }, onDismiss: () => {
                helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
            } },
            react_1.default.createElement(react_native_1.View, { style: styles.overlay },
                react_1.default.createElement(react_native_1.View, { style: styles.dialog },
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.dialogTitle }, `@${userHandle}さんを\nブロックしますか?`),
                    react_1.default.createElement(CustomText_1.default, { style: styles.dialogDescription }, `ブロックしたことは相手には通知されません。\nいつでもこの人のブロックを解除できます。`),
                    react_1.default.createElement(react_native_1.View, { style: styles.dialogRow },
                        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: handleCloseBlockModal, style: styles.dialogButton },
                            react_1.default.createElement(CustomText_1.default, { style: styles.dialogButtonLabel }, "\u30AD\u30E3\u30F3\u30BB\u30EB")),
                        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: handleBlockUser, style: [styles.dialogButton, styles.dialogButtonRight] },
                            react_1.default.createElement(CustomText_1.default, { style: [styles.dialogButtonLabel, { color: '#D32F2F' }] }, "\u30D6\u30ED\u30C3\u30AF")))))),
        react_1.default.createElement(react_native_1.Modal, { visible: muteModalVisible, animationType: "none", statusBarTranslucent: true, transparent: true, onRequestClose: handleCloseMuteModal, onShow: () => {
                helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
            }, onDismiss: () => {
                helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
            } },
            react_1.default.createElement(react_native_1.View, { style: styles.overlay },
                react_1.default.createElement(react_native_1.View, { style: styles.dialog },
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.dialogTitle }, `@${userHandle}さんを\nミュートしますか?`),
                    react_1.default.createElement(CustomText_1.default, { style: styles.dialogDescription }, `ミュートしたことは相手には通知されません。\nいつでもこの人のミュートを解除できます。`),
                    react_1.default.createElement(react_native_1.View, { style: styles.dialogRow },
                        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: handleCloseMuteModal, style: styles.dialogButton },
                            react_1.default.createElement(CustomText_1.default, { style: styles.dialogButtonLabel }, "\u30AD\u30E3\u30F3\u30BB\u30EB")),
                        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: handleMuteUser, style: [styles.dialogButton, styles.dialogButtonRight] },
                            react_1.default.createElement(CustomText_1.default, { style: [styles.dialogButtonLabel, { color: '#D32F2F' }] }, "\u30DF\u30E5\u30FC\u30C8")))))),
        react_1.default.createElement(ModalShare_1.default, { uri: `${window.location.origin}/users/${userHandle}`, visible: shareModalVisible, onClose: () => setShareModalVisible(false) })));
};
const styles = react_native_1.StyleSheet.create({
    viewLine: {
        borderBottomWidth: 1,
        borderBottomColor: "#ADADAD",
        paddingHorizontal: (0, scale_1.scale)(20),
        paddingVertical: (0, scale_1.scale)(16),
    },
    textConfirm: {
        color: "#FFFFFF",
    },
    textNote: {
        fontWeight: "300",
        fontSize: (0, scale_1.moderateScale)(14),
        color: "#292A33",
        lineHeight: (0, scale_1.moderateScale)(21),
    },
    viewModal: {
        backgroundColor: "#DDDDDD",
        width: (0, scale_1.scale)(220),
        borderRadius: (0, scale_1.scale)(6),
        overflow: 'hidden',
    },
    viewContain: {
        flex: 1,
    },
    overlay: {
        flex: 1,
        backgroundColor: 'rgba(0,0,0,0.7)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    dialog: {
        width: (0, scale_1.scale)(343),
        backgroundColor: '#FEFEFE',
        borderRadius: (0, scale_1.scale)(12),
    },
    dialogTitle: {
        width: '100%',
        paddingTop: (0, scale_1.scale)(24),
        paddingHorizontal: (0, scale_1.scale)(16),
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        color: '#292A33',
        textAlign: 'center'
    },
    dialogDescription: {
        width: '100%',
        marginTop: (0, scale_1.scale)(16),
        paddingHorizontal: (0, scale_1.scale)(16),
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        textAlign: 'center',
    },
    dialogRow: {
        width: '100%',
        height: (0, scale_1.scale)(48),
        flexDirection: 'row',
        marginTop: (0, scale_1.scale)(24),
        borderTopWidth: (0, scale_1.scale)(1),
        borderColor: '#DDDDDD'
    },
    dialogButton: {
        flex: 1,
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    dialogButtonRight: {
        borderLeftWidth: (0, scale_1.scale)(1),
        borderColor: '#DDDDDD'
    },
    dialogButtonLabel: {
        fontSize: (0, scale_1.moderateScale)(16),
        color: '#007AFF'
    }
});
exports.default = ModalSubUser;
